
import * as main from "../main";
import * as timeinterval from "../timeinterval";
import * as grid from "../grid";

let LABEL_ETooManyDays = "";
let dateTimeErrorMessageLabel = "";

function getUserId(): number | null {

    let cbb = $("#CBB_User").data("kendoDropDownList");
    if (cbb != null && cbb != undefined && cbb.value() != '') {
        return parseInt(cbb.value());
    }

    return null;
}

function getTimeInterval(): string | null {

    let ddl = $("#TimeIntervalID").data("kendoDropDownList");
    if (ddl != null && ddl != undefined && ddl.value() != '') {
        return ddl.value();
    }

    return null;
}

function setMessage(message: string): void {

    main.setHideDiv("DivLblTooMany", true);

    let lblEmsg = $("#LblTooMany");
    if (lblEmsg != null && lblEmsg != undefined) {
        lblEmsg.text(message);
    }
}

export function initialize(ETooManyDays: string, dateTimeErrorMessage: string): void {
    LABEL_ETooManyDays = ETooManyDays;
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    main.setHideDivBootstrap("periodSelector", false);
    grid.loadGridOptions("MsgUserAvailableLogGrid");
    searchButtonClicked();
}

export function searchButtonClicked(): void {
    $("#SearchButtonLoader").show();

    main.setHideDiv("errorMessage", false);
    main.setHideDiv("DivLblTooMany", false);
    main.setHideDiv("DivGridMsg", false);

    let selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
    let from = timeinterval.getBeginPeriodSelection(selectedInterval, null);
    let to = timeinterval.getEndPeriodSelection(selectedInterval, null);

    if (from != null && to != null) {
        let grid = $("#MsgUserAvailableLogGrid").data("kendoGrid");
        if (grid != null && grid != undefined) {
            grid.pager.dataSource.page(1);
            grid.dataSource.read();
        }
    }
    else {
        $("#SearchButtonLoader").hide();
        // make a message
        main.setHideDiv("errorMessage", true);

        let lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

export function getAdditionalData(): { userId: number, timestampFrom: Date, timestampTo: Date } {

    let userId = getUserId();
    let interval = parseInt(getTimeInterval()) || null;

    let fromLocal = timeinterval.getBeginPeriodSelection(interval, null);
    let toLocal = timeinterval.getEndPeriodSelection(interval, null);

    let tsDays = (toLocal.getTime() - fromLocal.getTime()) / (1000 * 3600 * 24);

    if (tsDays < 0 || tsDays >= 33) {
        setMessage(LABEL_ETooManyDays);
        fromLocal = toLocal = new Date(Date.now());
    }

    return {
        userId: userId,
        timestampFrom: fromLocal,
        timestampTo: toLocal
    };
}
